export function validateSubRegionData(data = {}) {
  let myErrors = {};

  if (!data.name) {
    myErrors.name = 'Sub Region Name is required!';
  }

  if (!data.blazeRegionId) {
    myErrors.blazeRegionId = 'Blaze Region is required!';
  }

  return {
    isValid: Object.values(myErrors).length === 0,
    myErrors
  }
}